/* Quick add from product cards, hotspots and the bag upsell. Uses Shopify's standard Ajax Cart endpoint (/cart/add.js)
   through LMB.cart (assets/cart.js, which also opens the bag), so Shopify's product_added_to_cart customer event
   fires for every pixel (verified: GA4 add_to_cart, Meta AddToCart).
   - [data-quick-add="<variant id>"]: adds one of that variant.
   - [data-quick-add-choose]: opens the size choice (aria-controls) for products with real variants.
   - [data-quick-add-close] / Escape / a click outside: closes the size choice.
   */
(() => {
  if (window.LMBQuickAdd) return;
  window.LMBQuickAdd = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const t = (key, fallback) => (window.LMB && LMB.strings && LMB.strings[key]) || fallback;

  const closeChooser = (panel, restoreFocus = true) => {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    const toggle = document.querySelector(`[aria-controls="${panel.id}"]`);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) toggle.focus({ preventScroll: true });
    }
  };

  const openChooser = (toggle) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    document.querySelectorAll('.card__sizes:not([hidden])').forEach((p) => closeChooser(p, false));
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    const first = panel.querySelector('[data-quick-add]:not([disabled])');
    if (first) first.focus({ preventScroll: true });
  };

  const announce = (el, message) => {
    const card = el.closest('[data-product-card], [data-quick-add-scope]');
    const status = card && card.querySelector('[data-quick-add-status]');
    if (status) status.textContent = message;
  };

  async function add(button) {
    const id = Number(button.dataset.quickAdd);
    if (!id || button.getAttribute('aria-busy') === 'true') return;
    const toggle = button.closest('.card__sizes')
      ? document.querySelector(`[aria-controls="${button.closest('.card__sizes').id}"]`)
      : null;
    const busy = toggle || button;
    busy.setAttribute('aria-busy', 'true');
    const chooserPanel = button.closest('.card__sizes');
    // Inside the open bag (upsell), keep the bag's own opener as the place focus returns to.
    const inDrawer = !!button.closest('cart-drawer');
    try {
      if (LMB.cart) {
        // assets/cart.js: /cart/add.js with the bag rendered in the same request; opens the bag.
        await LMB.cart.add({ items: [{ id, quantity: 1 }] }, { trigger: inDrawer ? undefined : busy });
      } else {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || t('quick_add_error', 'Could not add this piece.'));
        const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        LMB.updateCartCount(cart.item_count);
      }
      if (chooserPanel) closeChooser(chooserPanel, false);
      announce(busy, t('quick_add_added', 'Added to bag'));
      busy.classList.add('is-added');
      setTimeout(() => busy.classList.remove('is-added'), 1500);
    } catch (error) {
      announce(busy, error.message);
      busy.classList.add('is-error');
      setTimeout(() => busy.classList.remove('is-error'), 2500);
    } finally {
      busy.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-quick-add]');
    if (addButton) {
      event.preventDefault();
      add(addButton);
      return;
    }
    const chooser = event.target.closest('[data-quick-add-choose]');
    if (chooser) {
      event.preventDefault();
      const panel = document.getElementById(chooser.getAttribute('aria-controls'));
      panel && !panel.hidden ? closeChooser(panel) : openChooser(chooser);
      return;
    }
    const close = event.target.closest('[data-quick-add-close]');
    if (close) {
      closeChooser(close.closest('.card__sizes'));
      return;
    }
    document.querySelectorAll('.card__sizes:not([hidden])').forEach((panel) => {
      if (!panel.contains(event.target)) closeChooser(panel, false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest && event.target.closest('.card__sizes');
    if (panel) closeChooser(panel);
  });
})();
